import { render, staticRenderFns } from "./produits.vue?vue&type=template&id=c9dd9fba&scoped=true&"
import script from "./produits.vue?vue&type=script&lang=js&"
export * from "./produits.vue?vue&type=script&lang=js&"
import style0 from "./produits.vue?vue&type=style&index=0&id=c9dd9fba&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "c9dd9fba",
  null
  
)

export default component.exports